import type { FaireProductEntity } from "../../entity_types/product";

export const p_fzpwk2jqgc: FaireProductEntity = {
  token: "p_fzpwk2jqgc",
  type: "product",
  name: "White 7 in. Ceramic Modern Novelty Swirls Cat Figurine",
  brandToken: "b_oigrk5zybt",
  brandName: "Sagebrook Home",
  imageUrl:
    "https://cdn.faire.com/fastly/1d219c853d60ae5bed9bc7077290df3536bf1e24b78f3f1da2cddba5f79d02d9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cc5e8ebc45c43f39c2cd4472edb2cf2c0f45f0d0405f4f542838704ba74305ae.jpeg",
    "https://cdn.faire.com/fastly/4867a10977f8893db80c3c26af3436548d9c3f7e27328c7697e1f412ccb2f261.jpeg",
    "https://cdn.faire.com/fastly/2e118b605f54aa3bc48c1b6f6b916c88358627e2fb9e5f280ff16fbcc9ead63f.jpeg",
    "https://cdn.faire.com/fastly/5ccf9dc655a1f372c543d23452039656a2a9577d3711b1dc09d2a9aa6a02d516.jpeg",
    "https://cdn.faire.com/fastly/f1936109fd5dd7b7cd6dc336d2d15e6bbfe91547b20ea3ab430a54f4531bcb49.jpeg",
    "https://cdn.faire.com/fastly/dd97ef572b321796dabfebf21d5e375cfc76680788c554814a3c2bd0ef5d2319.jpeg",
    "https://cdn.faire.com/fastly/4f91583e557136ce733983039d28f1259985400b1fbb6548e8d07eb61ac33fae.jpeg",
    "https://cdn.faire.com/fastly/b88571389b7ffbe7d70b053a2ae4b9e8b15890d74df37b2b2222a6eec8bf52bb.jpeg",
    "https://cdn.faire.com/fastly/91d929d7a95a0ae0682dca6e238c28d9226f3d14efa8f85f0cba38ba2469acde.jpeg",
    "https://cdn.faire.com/fastly/193454e423e636de7930bf8c5faa9f7fca2e8c1cd6e85a7a16755acb2580f9c1.jpeg",
    "https://cdn.faire.com/fastly/d93e81801ea24307bea61d49a523f4a6887b00a6459b7a7aaffd82424707c509.jpeg",
    "https://cdn.faire.com/fastly/37d064270ac7f95836759dc7b5308a7546d43baac96eb108ca2bd6623f73509a.jpeg",
    "https://cdn.faire.com/fastly/380b00d666ae97e5f4cec9b78fcc885e23da8e0379cb06662787a0a44ae0469d.jpeg",
  ],
  priceDollars: 19.75,
  description:
    "• ELEGANT MODERN DESIGN - This ceramic cat figurine features intricate patterns and a stylish bow tie, adding a chic touch to your home decor. Its minimalist yet artistic design makes it a perfect accent for shelves, desks, or coffee tables.\n• PREMIUM QUALITY MATERIAL - Crafted from durable stoneware and ceramic, this decorative cat statue offers long-lasting beauty and stability. Its high-quality glaze finish ensures resistance to fading, making it a addition to your decor collection.\n• VERSATILE HOME ACCENT - This sleek ceramic cat figurine is ideal for enhancing any space. Whether placed in the living room, bedroom, office, or hallway, it effortlessly complements modern, minimalist, and boho-style interiors.",
  tags: [],
  msrpDollars: 49.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:55.294Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
